import React from "react";
import { connect } from "react-redux";
import Spinner from "components/common/Spinner";
import SearchBar from "components/menu/file-manager/search-bar";
import FoldersMenu from "components/menu/file-manager/internal/folders-menu";
import FilesMenu from "components/menu/file-manager/internal/files-menu";

class Index extends React.Component {
    render() {
        const { loading } = this.props;

        return (
            <div className=" dashboard file-manager">
                <SearchBar />

                <div className="row position-relative">
                    {!loading || <Spinner />}

                    <div className="col-4 p-0 border border-dark file-manager-menu">
                        <FoldersMenu />
                    </div>
                    <div className="col-8 p-0 border border-dark border-left-0 file-manager-menu">
                        <FilesMenu />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.fileManager.loading,
});

export default connect(
    mapStateToProps
)(Index);
